import React from 'react';
import { useRanking } from '@/hooks';
import { Close } from '@mui/icons-material';
import { BarProgress } from '../barProgress';
import { useMediaQuery } from '@mui/material';
import { Indicadores } from '@/context/ranking';
import { PetalPropsData } from '../../interfaces';
import { canvasSize } from '@/utils/canvasMatches';
import { makePosition, makeVirgula } from '@/utils/factorys';
import { buildRelativePositionValue } from '@/utils/buildRelativePositionTooltipValue';
import { Container, Delta, Label, Layer, LayerArea, RankingArea, RankingGeral } from './style';
interface TooltipContainerProps {
  data: any[]
  stateInfo: {
    indice: number,
    posicao: number,
    variacao_ano: number,
    variacao_decada: number,
    petals: any,
    sigla: string,
  }
  isMobile?: boolean;
  handleClose?: any;
}
export function TooltipContainer({ data, stateInfo, isMobile, handleClose}: TooltipContainerProps) {
  const { researchArea } = useRanking();

  function compare(a: any, b: any) {
    if (a.sigla < b.sigla) {
      return -1;
    }
    if (a.sigla > b.sigla) {
      return 1;
    }
    return 0;
  }

  data?.sort(compare);


  const handlePositionTooltip = () => {
    if (isMobile) {
      return '-10rem';
    };

    if (stateInfo.indice > buildRelativePositionValue(researchArea)) {
      return '-20rem';
    };

    return '-6rem';
  };

  return (
    <Container indiciValue={handlePositionTooltip()} isMobile={isMobile}>
      <Layer isMobile={isMobile}>
        <p>{stateInfo?.sigla}</p>
        <Close onClick={handleClose}></Close>
      </Layer>
      <RankingGeral>
        <Label>RANKING GERAL</Label>
        <p><b>Índice: </b> {makeVirgula(stateInfo?.indice)}</p>
        <p><b>Posição: </b>{stateInfo?.posicao}º</p>
        <p><b><Delta /> ano: </b>{makePosition(stateInfo?.variacao_ano)}</p>
        <p><b><Delta /> década: </b>{makePosition(stateInfo?.variacao_decada)}</p>
      </RankingGeral>
      <RankingArea>
        <Label>RESULTADO POR ÁREA</Label>
        <div className='boxLabels'>
          <small></small>
          <small><b>indice</b></small>
          <small style={{ width: "60px", textAlign: "center", marginLeft: "50px" }}><b>Posição no ranking</b></small>
        </div>
        {data.map((step: PetalPropsData) => {
          return (
            <LayerArea key={step.sigla}>
              <p className='nome'>{Indicadores[step.sigla]?.label}</p>
              <BarProgress data={step} color={Indicadores[step.sigla]?.color} />
              <div style={{ textAlign: 'center', minWidth: '40px' }}>
                <p className='indice'>{step.posicao}°</p>
              </div>
            </LayerArea>
          )
        })}

      </RankingArea>
    </Container>
  )
}
